import React from 'react';

import { Controller } from 'react-hook-form';

import { UseCreateTemplateFromReportModalLogic } from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/CreateTemplateFromReportModal.logic';
import { UseCreateTemplateFromReportModalProvider } from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/CreateTemplateFromReportModal.provider';
import classes from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/components/CreateTemplateFromReportForm/CreateTemplateFromReportForm.module.scss';
import {
    MAX_CHAR_NAME_VALIDATION,
    MIN_CHAR_NAME_VALIDATION,
    NAME_IS_REQUIRED,
    TEMPLATE_SELECTION_IS_REQUIRED,
} from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/components/CreateTemplateFromReportForm/components/TemplateName/TemplateName.consts';
import { Select } from 'components/DesignSystem/Select';
import { TextInput } from 'components/DesignSystem/TextInput/TextInput';
import { CustomizedFormErrorMessage } from 'components/common';

interface Props {
    logic: UseCreateTemplateFromReportModalLogic['logic'];
    api: UseCreateTemplateFromReportModalProvider['api'];
}

export const TemplateName = ({ logic, api }: Props) => {
    const { setValue, control, formState, watch } = logic.form;

    return (
        <>
            <div className={logic.radioOption === 'new' ? '' : classes.hidden}>
                <Controller
                    render={({ field }) => {
                        return (
                            <TextInput
                                {...field}
                                placeholder={'New Template name...'}
                                maxLength={50}
                                onClear={() => {
                                    setValue('templateName', '');
                                }}
                            />
                        );
                    }}
                    name={'templateName'}
                    control={control}
                    rules={{
                        required: logic.radioOption === 'new' ? NAME_IS_REQUIRED : false,
                        minLength:
                            logic.radioOption === 'new' ? { value: 2, message: MIN_CHAR_NAME_VALIDATION } : undefined,
                        maxLength: { value: 50, message: MAX_CHAR_NAME_VALIDATION },
                    }}
                />
                {formState.errors.templateName && (
                    <CustomizedFormErrorMessage text={formState.errors.templateName.message} />
                )}
            </div>
            <div className={logic.radioOption === 'overwrite' ? '' : classes.hidden}>
                <Controller
                    render={({ field }) => (
                        <Select<ISelectOption<number>>
                            {...field}
                            value={logic.templateOptions.find((item) => item.value === watch('templateId')) || null}
                            onChange={(value) => {
                                if (value) {
                                    field.onChange(value.value);
                                    setValue('templateId', value.value);
                                    const currentTemplate = api.getReportTemplates.data?.find(
                                        (template) => template.id === value.value,
                                    );
                                    if (currentTemplate) {
                                        setValue('templateDescription', currentTemplate.description);
                                        setValue('templateName', currentTemplate.name ?? '');
                                        setValue('selectedTags', currentTemplate.tags);
                                    }
                                } else {
                                    setValue('templateId', null);
                                }
                            }}
                            options={logic.templateOptions}
                            isClearable={true}
                            placeholder={'Select Template...'}
                        />
                    )}
                    name={'templateId'}
                    control={control}
                    rules={{
                        required: logic.radioOption === 'overwrite' ? TEMPLATE_SELECTION_IS_REQUIRED : false,
                    }}
                />
                {formState.errors.templateId && (
                    <CustomizedFormErrorMessage text={formState.errors.templateId.message} />
                )}
            </div>
        </>
    );
};
